import { fromJS } from 'immutable';

import * as ActionTypes from '../constants/ActionTypes';

const initialState = fromJS({
  followings: {},
  total: null,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCHED_TOPIC:
      // @TODO
      return state
        .mergeIn(['followings'], fromJS(action.payload.entities.followings))
        .set(
          'total',
          action.payload.entities.topics[
            action.payload.result.topics.toString()
          ].total_followings,
        );

    case ActionTypes.FOLLOWED_TOPIC:
      return state
        .removeIn(['followings', 'draft'])
        .mergeIn(['followings'], fromJS(action.payload.entities.followings))
        .setIn(['total'], state.getIn(['total']) + 1);

    case ActionTypes.UNFOLLOWED_TOPIC:
      return state
        .removeIn(['followings', action.payload.result.toString()])
        .setIn(['total'], state.getIn(['total']) - 1);

    case ActionTypes.FETCHED_FOLLOWINGS:
      return state
        .mergeIn(
          ['followings'],
          fromJS(action.payload.followings.entities.followings),
        )
        .set('total', action.payload.total)
        .set('followings_fetched_at', Date.now());

    case ActionTypes.UPDATE_SETTINGS:
      return state.mergeIn(
        ['followings'],
        fromJS(action.payload.entities.followings),
      );

    default:
      return state;
  }
};
